import fasie from "../images/fasie.svg";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__block">
        {localStorage.getItem("lang") == "ru" ? (
          <div className="footer__block-content">
            <div>
              <p className="footer__copiright">
                &copy; {year} ООО "МАД РЕДИС Лаб"
              </p>
              <p className="footer__text">6140051 Пермь Уинская 4</p>
              <p className="footer__text">ИНН: 5906174862 КПП:590601001</p>
            </div>
            <Link to="https://fasie.ru" target="blank" rel="noreferrer"><img src={fasie} className="footer__fasie" alt="FASIE" /></Link>
          </div>
        ) : (
          <p className="footer__copiright">&copy; {year} SportUp</p>
        )}
      </div>
    </footer>
  );
}
